// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2jJfi","label":"LabeledBox_label__1xTBJ"};